var _effectorFileName = "/builds/gmini/front-ui-kit/src/ResizableColumns/utils/correct-widths.ts";
import { convertPxToPc } from './convert';
export function correctWidths({
  widthsPc,
  foldedWidthPx,
  containerW,
  prevContainerW = containerW
}) {
  const sum = widthsPc.reduce((acc, w) => acc + w, 0);
  const delta = 100 - sum;
  const foldedWidthPc = convertPxToPc(foldedWidthPx, containerW);
  const prevFoldedWidthPc = convertPxToPc(foldedWidthPx, prevContainerW);
  const mostBigIdx = widthsPc.reduce((prevIdx, w, idx) => {
    if (w >= widthsPc[prevIdx]) {
      return idx;
    }

    return prevIdx;
  }, 0); // Проверяем чтоб не было элемментов меньше минимальной ширины

  const nextWidths = widthsPc.map(w => w <= prevFoldedWidthPc ? foldedWidthPc : w);
  const firstExpandedIdx = widthsPc.findIndex(w => w > foldedWidthPc);
  const mostSmallExpandedIdx = widthsPc.reduce((prevIdx, w, idx) => {
    if (w <= widthsPc[prevIdx] && w > foldedWidthPc) {
      return idx;
    }

    return prevIdx;
  }, firstExpandedIdx); // sum меньше 100%

  if (delta > 0) {
    nextWidths[mostSmallExpandedIdx] = nextWidths[mostSmallExpandedIdx] + delta;
  } else {
    nextWidths[mostBigIdx] = nextWidths[mostBigIdx] + delta;
  }

  return nextWidths;
}